// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1k4zG","footer":"ModalFilter_footer__2vqBi"};